import React, { useEffect } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  getAllTrainings,
  addMakePublicTraining,
  deleteTraining,
} from "../../actions/learning_provider/training_action";
import { APP_URL, UI_URL } from "../../config/api";
import { reactiveUserTraining } from "../../actions/learning_provider/lp_users_action";
import { WhatsappShareButton, WhatsappIcon } from "next-share";
import { ToastContainer, toast } from "react-toastify";
const ShowAllTrainings = () => {
  const state = useSelector((state) => state.trainingReducer);
  const traningReducer = useSelector((state) => state.trainingUserReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("page_available");
    localStorage.removeItem("startSlug");
    localStorage.removeItem("page_available");
    if (state.list.length == 0) {
      dispatch(getAllTrainings());
    }
  }, []);

  const handelClick = (slug) => {
    navigate("/add-training-user/" + slug);
  };

  const handelUserClick = (slug) => {
    navigate("/show-training-users/" + slug);
  };

  const handelPublicClick = (id) => {
    dispatch(addMakePublicTraining({ id: id }));
  };

  const checkCallFun = (slug) => {
    //navigate("/conference/" + slug);

    let checkMeeting = localStorage.getItem("start");
    localStorage.setItem("start", true);
    localStorage.setItem("startSlug", slug);
    window.open(UI_URL + "/conference/" + slug);
    // let workingTraining = localStorage.getItem("workingTraining");
    // let trCount = localStorage.getItem("trCount");
    // if (!trCount && !workingTraining) {
    //   localStorage.setItem("trCount", 1);
    //   window.open(UI_URL + "/training/" + slug);
    // }
    //localStorage.setItem("workingTraining", slug);
    //window.open(UI_URL + "/training/" + slug);
  };

  const getDeleteTraining = (slug) => {
    dispatch(deleteTraining({ slug: slug }));
  };

  const handelActiveClick = (slug) => {
    dispatch(reactiveUserTraining({ slug: slug }));
  };

  if (state.is_done) {
    dispatch(getAllTrainings());
  }

  let location = useLocation();
  if (location.pathname === "/all-trainings/") {
    setTimeout(() => {
      window.close("/all-trainings/");
    }, 2000);
  }
  const trainingSyllabus = (slug) => {
    navigate("/training-syllabus/" + slug);
  };

  function copyText(link, name, start_date) {
    let url = UI_URL + "/public/conference/" + link;
    let meeting =
      "Hi Welcome to Educloudlabs, Your " +
      name +
      " Training  Start on " +
      start_date +
      " join the below Link. " +
      url;
    navigator.clipboard.writeText(meeting);
    toast("Training Link Copied!", {
      type: "success",
      position: "top-center",
    });
  }
  const addAssessmentQuestion = (slug) => {
    navigate("/assessment/add/" + slug);
  };

  return (
    <AppBody
      loading={state.loading || traningReducer.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/create-training"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Upcoming Trainings
              </h4>
            </div>
            <div className="card-body p-4 w-100 border-0 ">
              <ToastContainer />
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Meeting ID</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Total Day</th>
                      <th>Total Participants</th>
                      <th>Available</th>
                      <th className="tblaction">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.name}</td>
                          <td>{li.link}</td>
                          <td>{li.start_date}</td>
                          <td>{li.end_date}</td>
                          <td>{li.total_training_day}</td>
                          <td>{li.number_of_participants}</td>
                          <td>
                            {li.is_public === 0 ? "Not Public" : "Public"}
                          </td>
                          <td className="tblaction">
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Add"
                              onClick={() => handelClick(li.slug)}
                            >
                              <i className="feather-plus-circle"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Assign Trainer"
                              onClick={() =>
                                navigate("/assing/trainer/" + li.slug)
                              }
                            >
                              <i className="fa fa-tasks"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Users"
                              onClick={() => handelUserClick(li.slug)}
                            >
                              <i className="feather-users"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              title={
                                li.is_public === 0
                                  ? "Make Public"
                                  : "Stop Public"
                              }
                              onClick={() => handelPublicClick(li.id)}
                            >
                              <i className="feather-globe"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              value={"Start"}
                              readOnly={li.status === 1 ? true : false}
                              title="Start"
                              onClick={() => {
                                li.totalTopics > 0
                                  ? trainingSyllabus(li.slug)
                                  : checkCallFun(li.slug);
                              }}
                            >
                              <i className="feather-play-circle"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              value={"Start"}
                              readOnly={li.status === 1 ? true : false}
                              title="Syllabus"
                              onClick={() => trainingSyllabus(li.slug)}
                            >
                              <i className="fa fa-book"></i>
                            </a>

                            {li.status === 0 && (
                              <a
                                className="line-height-36 custom-icon mr-2"
                                title="Delete"
                                onClick={() => getDeleteTraining(li.slug)}
                              >
                                <i className="feather-trash-2"></i>
                              </a>
                            )}
                            
                            <a
                              className="line-height-36 custom-icon mr-2"
                              value={"Copy Meeting Link"}
                              title="Copy Meeting Link"
                              onClick={() =>
                                copyText(li.link, li.name, li.start_date)
                              }
                            >
                              <i className="far fa-clipboard"></i>
                            </a>

                            <a
                              className="line-height-36 custom-icon mr-2"
                              value={"Copy Meeting Link"}
                              title="Copy Meeting Link"
                              onClick={() =>
                                copyText(li.link, li.name, li.start_date)
                              }
                            >
                              <i className="far fa-server"></i>
                            </a>



                            <WhatsappShareButton
                              url={UI_URL + "/public/conference/" + li.link}
                              title={
                                "Hi Welcome to Educloudlabs, Your " +
                                li.name +
                                " Training  Start on " +
                                li.start_date +
                                " join the below Link."
                              }
                              separator=":: "
                            >
                              <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              value={"Assessment"}
                              title="Assessment"
                              onClick={() => addAssessmentQuestion(li.slug)}
                            >
                              <i className="fa fa-question-circle"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowAllTrainings;
